<template>
  <div>
    <a-descriptions bordered size="small" title="" :column="6">
      <a-descriptions-item label="设备名称" :span="2">{{ model.name }}</a-descriptions-item>
      <a-descriptions-item label="是否是虚拟设备">{{ model.sign ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="设备编号">{{ model.equipmentNumber }}</a-descriptions-item>
      <a-descriptions-item label="公司名称">{{ model.subcompanyname }}</a-descriptions-item>
      <a-descriptions-item label="设备状态">{{ model.equipmentStatusName }}</a-descriptions-item>
      <a-descriptions-item label="规格型号">{{ model.specification }}</a-descriptions-item>
      <a-descriptions-item label="设备分类">{{ model.equipmentTypeName }}</a-descriptions-item>
      <a-descriptions-item label="内部编码">{{ model.interiorCode }}</a-descriptions-item>
      <a-descriptions-item label="归口部门">{{ model.relevantdeptname }}</a-descriptions-item>
      <a-descriptions-item label="归口负责人">{{ model.relevantdeptUserName }}</a-descriptions-item>
      <a-descriptions-item label="使用部门">{{ model.usedeptname }}</a-descriptions-item>
      <a-descriptions-item label="使用负责人">{{ model.principalName }}</a-descriptions-item>
      <a-descriptions-item label="资产卡片号">{{ model.assetNumber }}</a-descriptions-item>
      <a-descriptions-item label="设备品牌">{{ model.brand }}</a-descriptions-item>
      <a-descriptions-item label="首次投用日期">{{ model.entryDate }}</a-descriptions-item>
      <a-descriptions-item label="报废日期">{{ model.retirementDate }}</a-descriptions-item>
      <a-descriptions-item label="重要分类">{{ model.importanceType }}</a-descriptions-item>
      <a-descriptions-item label="展示方式">{{ model.displayType === '1' ? '树状展示' : '抽屉展示' }}</a-descriptions-item>
      <a-descriptions-item label="压力容器">{{ model.isYlrqPeculiarity ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="特种设备">{{ model.isTzsbPeculiarity ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="环保特性">{{ model.isHbPeculiarity ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="设施位置/地址" :span="3">{{ model.address }}</a-descriptions-item>
      <a-descriptions-item label="备注" :span="3">{{ model.remark }}</a-descriptions-item>
      <!--      <a-descriptions-item label="已使用年限">{{ model.ndjar }}</a-descriptions-item>-->
      <!--      <a-descriptions-item label="资产信息状态">{{ model.assetInfoStatus }}</a-descriptions-item>-->
    </a-descriptions>
    <!--    <a-descriptions bordered size="small" title="资产信息" :column="6">-->
    <!--      <a-descriptions-item label="资产描述">{{ model.txt50 }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="资产编码">{{ model.anln1 }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="资产分类">{{ model.txk20 }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="购置价值">{{ model.kansw }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="现值">{{ model.qmjz }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="首次购置日期">{{ model.zugdt }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="不活动日期">{{ model.deakt }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="资产使用年限">{{ model.ndjar }}</a-descriptions-item>-->
    <!--    </a-descriptions>-->
    <!--    <a-descriptions bordered size="small" title="专项信息" :column="6">-->
    <!--      <a-descriptions-item label="是否核心设备">{{ model.ifkernel }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="专项类型">{{ model.specialTypeName }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="是否环保设备">{{ model.ifenvionmental }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="是否保密设备">{{ model.ifsecurity }}</a-descriptions-item>-->
    <!--    </a-descriptions>-->
    <!--    <a-descriptions bordered size="small" title="其他信息" :column="6">-->
    <!--      <a-descriptions-item label="图号">{{ model.figureNumber }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="SAP设备编号">{{ model.sapNumber }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="SAP设备分类">{{ model.sapTypeName }}</a-descriptions-item>-->
    <!--      <a-descriptions-item label="备注" :span="3">{{ model.remark }}</a-descriptions-item>-->
    <!--    </a-descriptions>-->
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log('watch_record', model)
        this.initDetail(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: {
        xxx: 'xxxxxx'
      }
    }
  },
  methods: {
    initDetail (model) {
      this.model.entryDate = model.entryDate ? moment(model.entryDate).format('YYYY-MM-DD') : ''
      this.model.retirementDate = model.retirementDate ? moment(model.retirementDate).format('YYYY-MM-DD') : ''
    }
  }
}
</script>

<style scoped>

</style>
